<template>
    <b-checkbox v-if="dataRow.draw"
        v-model="dataRow.uploaded" class="filecheck"
    >
        {{ dataRow.corto }}
    </b-checkbox>
</template>

<script>
export default {
  name: 'FileCheckBox',
  props: {
    dataRow: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
}
</script>
<style scoped>
.filecheck {
}
</style>